import { LoadingOverlay } from '@mantine/core';
import { FC, memo } from 'react';

import styles from './styles.module.css';

type Props = {
  visible: boolean;
};

export const PageLoader: FC<Props> = memo(({ visible = false }) => (
  <LoadingOverlay
    visible={visible}
    zIndex={1000}
    overlayProps={{ blur: 1, center: true, fixed: true }}
    loaderProps={{ type: 'bars' }}
    classNames={{
      loader: styles.loader,
      overlay: styles.overlay,
    }}
  />
));
